class InjectReturnTo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const url = new URL(window.location);
    const returnTo = url.searchParams.get('return_to');

    if (!returnTo) return;

    this.innerHTML = `
    <input type="hidden" name="return_to" value="${ returnTo }">
    `
  }

  disconnectedCallback() {

  }
}

if (!customElements.get("inject-return-to")) {
  customElements.define("inject-return-to", InjectReturnTo);
}